import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { BigBreadcrumbs, WidgetGrid } from '../../../components';
import Moment from '../../../components/utils/Moment';
import { requestPatientDeductibleStatus } from '../../../store/patient-deductible-status/PatientDeductibleStatusActions';
import { hostTitle } from '../../../config/ui';

class PatientDeductibleDetail extends React.Component {

  componentWillMount() {
    this.props.getPatientDeductibleStatus(this.props.params.id, {
      tenantID: this.props.tenantId,
    });
  }

  onCancel = () => {
    hashHistory.push(`/patient-deductible-status/`);
  };


  render() {
    const {
      data: { patientDeductibleStatus, isLoading },
    } = this.props;

    return (
      <div id="content">
        {patientDeductibleStatus.id && (
          <Helmet title={`${patientDeductibleStatus.id} – ${hostTitle()}`} />
        )}
        <BigBreadcrumbs
          items={[
            'Administration',
            { title: 'Patient Deductible Status Manager', route: '/patient-deductible-status' },
            'Detail',
          ]}
          icon="fa fa-fw fa-database"
          className=""
        />

        <WidgetGrid>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="product-content product-wrap clearfix product-deatil">
                {isLoading &&
                  <div className="spinner"></div>
                }
                {patientDeductibleStatus.id && (
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        className="btn btn-primary pull-right"
                        onClick={this.onCancel}>
                        Back
                      </button>
                      <h2 className="name">
                        Patient Deductible Status Details
                      </h2>
                      <hr className="simple" />
                      <br />

                      <div className="row">
                        <div className="col-md-6">
                          <dl>
                            <dt>Name</dt>
                            <dd>
                              {patientDeductibleStatus.firstName} {patientDeductibleStatus.lastName}
                            </dd>
                            <br />

                            <dt>Date of Birth</dt>
                            <dd>
                              <Moment date={patientDeductibleStatus.dob} format="MM/DD/YYYY" />
                            </dd>
                            <br />

                            <dt>Group Id</dt>
                            <dd>
                              {patientDeductibleStatus.insGroupId}
                            </dd>
                            <br />

                            <dt>Policy Prefix</dt>
                            <dd>
                              {patientDeductibleStatus.insPolicyPrefix}
                            </dd>
                            <br />

                            <dt>Policy Id</dt>
                            <dd>
                              {patientDeductibleStatus.insPolicyId}
                            </dd>
                            <br />

                            <dt>Individual Id</dt>
                            <dd>
                              {patientDeductibleStatus.insIndividualId}
                            </dd>
                            <br />

                            <dt>Unique Member Id</dt>
                            <dd>
                              {patientDeductibleStatus.insUniqueMemberId}
                            </dd>
                            <br />

                            <dt>Is Hdhp Member</dt>
                            <dd>
                              {patientDeductibleStatus.isHdhpMember ? 'True' : 'False'}
                            </dd>
                            <br />

                            <dt>Modified Date</dt>
                            <dd>
                              {patientDeductibleStatus.modifiedDate}
                            </dd>
                            <br />

                          </dl>
                        </div>
                        <div className="col-md-6">
                          <dl>
                            <dt>Hint Id</dt>
                            <dd>
                              {patientDeductibleStatus.hintId}
                            </dd>
                            <br />

                            <dt>Individual Deductible</dt>
                            <dd>
                              {patientDeductibleStatus.individualDeductible}
                            </dd>
                            <br />

                            <dt>Individual OutOfPocket</dt>
                            <dd>
                              {patientDeductibleStatus.individualOutOfPocket}
                            </dd>
                            <br />

                            <dt>Family Deductible</dt>
                            <dd>
                              {patientDeductibleStatus.familyDeductible}
                            </dd>
                            <br />

                            <dt>Family OutOfPocket</dt>
                            <dd>
                              {patientDeductibleStatus.familyOutOfPocket}
                            </dd>
                            <br />

                            <dt>Met Deductible</dt>
                            <dd>
                              {patientDeductibleStatus.metDeductible ? 'True' : 'False'}
                            </dd>
                            <br />

                            <dt>Met Oop Max</dt>
                            <dd>
                              {patientDeductibleStatus.metOopMax ? 'True' : 'False'}
                            </dd>
                            <br />

                            <dt>Source</dt>
                            <dd>
                              {patientDeductibleStatus.source}
                            </dd>
                            <br />
                          </dl>
                        </div>
                      </div>
                        
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.patientdeductiblemanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  dispatch => ({
    getPatientDeductibleStatus: (id, params) => dispatch(requestPatientDeductibleStatus(id, params)),
  }),
)(PatientDeductibleDetail);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/PatientDeductibleDetail.js